let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6wr18"), load("6CBhM"), load("dXF2m"), load("ffEVr"), load("2sCab")]).then(() => parcelRequire('3GuAz'));